export default __webpack_public_path__ + "static/media/done-chk-white.7fcfd96e.svg";